import { blurImageData } from '@kayahr/stackblur';
import { useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

type BlurOverlayProps = {
  visible: boolean;
  getVideoElement: () => HTMLVideoElement | null;
};

export const BlurOverlay = ({
  visible = false,
  getVideoElement,
}: BlurOverlayProps) => {
  const overlayRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const blurImage = async () => {
      if (!overlayRef.current) return;

      const canvas = document.createElement('canvas') as HTMLCanvasElement;
      const video = getVideoElement();

      if (!video) return;

      canvas.width = video.videoWidth / 4;
      canvas.height = video.videoHeight / 4;
      const ctx = canvas.getContext('2d');
      const img = overlayRef.current.querySelector('img') as HTMLImageElement;

      if (!ctx) return;

      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

      const radius = 15; // Valid range: 0-254
      const withAlpha = false; // Optional, defaults to true
      blurImageData(imageData, radius, withAlpha);

      ctx.putImageData(imageData, 0, 0);

      img.src = canvas.toDataURL('image/png'); // will throw if canvas is tainted
    };

    if (visible) {
      blurImage();
    }
  }, [visible, getVideoElement]);

  return (
    <div
      ref={overlayRef}
      className={twMerge([
        'absolute w-full h-full z-[99991] pointer-events-none opacity-0 transition-opacity duration-200',
        visible && 'opacity-100',
      ])}
    >
      <img className="w-full h-full object-contain aspect-video" />
    </div>
  );
};
